module.exports = __webpack_public_path__ + "media/warning.5dff99cc.mp3";